import { render, staticRenderFns } from "./DictamenInmueble.vue?vue&type=template&id=4a410d6c&scoped=true"
import script from "./DictamenInmueble.vue?vue&type=script&lang=js"
export * from "./DictamenInmueble.vue?vue&type=script&lang=js"
import style0 from "./DictamenInmueble.vue?vue&type=style&index=0&id=4a410d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a410d6c",
  null
  
)

export default component.exports